export const environment = {
  production: true,
  apiUrl:  'https://ha.api.mailytica.ai'
};
